import { combineReducers } from 'redux'
import conversationSelected from './conversationSelected'
import contactViewPanelVisible from './contactViewPanelVisible'
import threadViewVisible from './threadViewVisible'
import chatSearchVisible from './chatSearchVisible'
import conversationSearch from './conversationSearch'
import conversationsListSearch from './conversationsListSearch'
import conversation from './conversation'
import contactSearch from './contactSearch'
import contactSelected from './contactSelected'
import recentlySent from './recentlySent'
import emailDialog from './emailDialog'
import emailsLoaded from './emailsLoaded'
// import messageType from './messageType'
import lastReceivedDateTimes from './lastReceivedDateTimes'
import to from './to'
// import newConversations from './newConversations'
import newConversationSelected from './newConversationSelected'
import fromNumberSelected from './fromNumberSelected'
import lastInteraction from './lastInteraction'
import sending from './sending'
import fromEmailSelected from './fromEmailSelected'
import messageMenuOpen from './messageMenuOpen'
import fromName from './fromName'
import imagesLoaded from './imagesLoaded'
import conversationsListFilter from './conversationsListFilter'
import conversationsListCursor from './conversationsListCursor'
import smsInputOverride from './smsInputOverride'
import conversationsListUserFilter from './conversationsListUserFilter'
import hideStopRequests from './hideStopRequests'

// so some state gets updated with a ref being shared or something
const whatever = (state = false, action) => {
  if (action.type === 'whatever') {
    if (action.payload) {
      return action.payload
    }
    return !Boolean(state)
  } else {
    return state
  }
}

export default combineReducers({
  conversationSelected,
  contactViewPanelVisible,
  threadViewVisible,
  chatSearchVisible,
  conversationSearch,
  conversationsListSearch,
  conversation,
  contactSearch,
  contactSelected,
  recentlySent,
  emailDialog,
  emailsLoaded,
  // messageType,
  lastReceivedDateTimes,
  to,
  // newConversations,
  newConversationSelected,
  fromNumberSelected,
  fromEmailSelected,
  lastInteraction,
  sending,
  messageMenuOpen,
  fromName,
  whatever,
  imagesLoaded,
  conversationsListFilter,
  conversationsListCursor,
  conversationsListUserFilter,
  smsInputOverride,
  hideStopRequests,
})
